export enum FORM_ELEMENTS {
  SECTION_TITLE = 'SECTION_TITLE',
  CHECKBOX_GROUP = 'CHECKBOX_GROUP',
  RADIO_GROUP = 'RADIO_GROUP',
  SLIDER = 'SLIDER',
  NUMBER_PICKER = 'NUMBER_PICKER',
  TOGGLE_BUTTON_GROUP = 'TOGGLE_BUTTON_GROUP',
  TIME_SLIDER = 'TIME_SLIDER',
  SELECT = 'SELECT',
  SECTION_HIGHLIGHT = 'SECTION_HIGHLIGHT',
  HIGHLIGHT_SELECTOR = 'HIGHLIGHT_SELECTOR',
  SWITCH = 'SWITCH',
}
